import React from 'react';
import { withTranslation } from 'react-i18next';
import EyeIcon from 'mdi-react/EyeIcon';

const RevealArticle = ({t, onClick}) => (
    <span className="button-tag"><button
        className="draft_table-btn"
        title={t('posts.articles.tooltips.show_article_on_blog')}
        type="button"
        onClick={onClick}><EyeIcon/></button></span>
)

export default withTranslation('dashboard')(RevealArticle);
